import { BaseItemProperties, DEFAULT_BASE_PROPERTIES } from '../BaseItem/base-item-properties';

export interface InteractiveColorProperties {
  inputColor: string;
}

export interface InteractiveCaptionLeftProperties {
  inputCaptionLeft?: string;
  textBgColor?: string;
  text?: string;
}

export interface InteractiveItemProperties extends InteractiveColorProperties, BaseItemProperties {
  resultValue: string;
  resultUser: string;
  resultTime: string;
}

export const DEFAULT_INTERACTIVE_PROPERTIES: InteractiveItemProperties = {
  ...DEFAULT_BASE_PROPERTIES,

  inputColor: '',

  resultValue: '',
  resultUser: '',
  resultTime: ''
};
